import { __values } from "tslib";
import TableOperationUtils from '../model/table-operation-utils';
export function convertModelToPersistentData(model) {
    var e_1, _a;
    var _b;
    var tableInfo = TableOperationUtils.getTableInfo(Object.getPrototypeOf(model));
    if (!tableInfo) {
        return model;
    }
    var persistentData = {};
    try {
        for (var _c = __values(tableInfo.properties.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
            var property = _d.value;
            var persistenceDataKey = (_b = property.alias) !== null && _b !== void 0 ? _b : property.name;
            persistentData[persistenceDataKey] = model[property.name];
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return persistentData;
}
/**
 * get the model real property and value from persistent data,
 * in this process will transform alias property to model real property name
 */
function getModelKeyValues(persistentData, tableInfo) {
    var e_2, _a;
    var _b;
    var keyValueRecord = {};
    try {
        for (var _c = __values(tableInfo.properties.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
            var property = _d.value;
            var persistenceDataKey = (_b = property.alias) !== null && _b !== void 0 ? _b : property.name;
            keyValueRecord[property.name] = persistentData[persistenceDataKey];
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return keyValueRecord;
}
export function convertPersistentDataToModel(persistentData, ModelClass) {
    var e_3, _a;
    if (persistentData === undefined || persistentData === null) {
        return null;
    }
    var tableInfo = TableOperationUtils.getTableInfo(ModelClass.prototype);
    if (!tableInfo) {
        return persistentData;
    }
    var modelKeyValues = getModelKeyValues(persistentData, tableInfo);
    var modelInstance = new ModelClass(modelKeyValues);
    try {
        for (var _b = __values(Object.keys(modelKeyValues)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            if (modelKeyValues[key] !== undefined) {
                modelInstance[key] = modelKeyValues[key];
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return modelInstance;
}
//# sourceMappingURL=model-data-converter.js.map